export const CompareClose = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='9.22498' cy='9.07843' r='8.75' fill='#B1B1B1' />
      <path
        d='M12.9761 11.6293C13.3079 11.9613 13.3079 12.4977 12.9761 12.8297C12.8105 12.9952 12.5932 13.0784 12.3758 13.0784C12.1585 13.0784 11.9412 12.9952 11.7757 12.8297L9.22502 10.2788L6.67433 12.8297C6.5088 12.9952 6.29151 13.0784 6.07423 13.0784C5.85679 13.0784 5.6395 12.9952 5.47397 12.8297C5.14214 12.4977 5.14214 11.9613 5.47397 11.6293L8.02482 9.07854L5.47397 6.52778C5.14214 6.19579 5.14214 5.6594 5.47397 5.3274C5.80596 4.99556 6.34234 4.99556 6.67433 5.3274L9.22502 7.87831L11.7757 5.3274C12.1077 4.99556 12.6441 4.99556 12.9761 5.3274C13.3079 5.6594 13.3079 6.19579 12.9761 6.52778L10.4252 9.07854L12.9761 11.6293Z'
        fill='white'
      />
    </svg>
  )
}
